var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"LYljwxG9Wh479CGp_LIsD"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["mellin-multi-site@webranking-srl"]={id:"LYljwxG9Wh479CGp_LIsD"};
      